<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/reportes_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Toma decisiones de tu negocio en <br class="is-hidden-touch" />base
            a información real y actualizada
          </h2>
          <p class="my-3">
            Genera reportes excel y PDF sobre<br class="is-hidden-touch" />
            informaciñon valiosa de tu negocio. Mira
            <br class="is-hidden-touch" />que tán bien te está yendo.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--left no-padding--right">
      <div class="columns is-desktop section__video">
        <div class="reportes column column-50 column-offset-10">
          <img class="img-center" src="../assets/images/reporte_1.svg" alt="" />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Reportes claros y sencillo que <br class="is-hidden-touch" />te
              dan información actualizada <br class="is-hidden-touch" />de tu
              negocio
            </h3>
            <p>
              Olvidate de los dolores de<br class="is-hidden-touch" />
              cabeza para cuadrar tus<br class="is-hidden-touch" />
              operaciones al final del día.<br class="is-hidden-touch" />
              ContaFácil permite saber el<br class="is-hidden-touch" />
              estado de tu negocio al<br class="is-hidden-touch" />
              instante.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-ml-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="reportes column column-50">
          <img src="../assets/images/reporte_2.svg" alt="" />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Ten una vista real de las
              <br class="is-hidden-touch" />operaciones en tus puntos de
              <br class="is-hidden-touch" />venta y genera reportes al
              <br class="is-hidden-touch" />instante
            </h3>
            <p>
              Invita a tu contador a<br class="is-hidden-touch" />
              ContaFácil y permite que<br class="is-hidden-touch" />
              genere los reportes<br class="is-hidden-touch" />
              necesarios para tus<br class="is-hidden-touch" />
              declaraciones mensuales.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-mr-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules";
import OneView from "../components/OneView";
import { EventBus } from "@/event-bus";
export default {
  name: "Ventas",
  components: {
    TabModules,
    OneView
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/848sDgMQ6Fo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // background-image: url("../assets/images/banners/reportes_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  // height: calc(100vh - 75px);
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    background-color: transparent;
    // height: 75%;
    margin-top: auto;
    width: 100%;
    // padding: 1rem;
    p {
      width: 100%;
    }
  }
  @include tablet() {
    background-image: none;
    // height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      // padding: 1rem;
      // padding-top: 10rem;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1024px) {
    background-image: url("../assets/images/banners/reportes.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // height: calc(100vh - 100px);
    // max-height: 500px;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    background-image: url("../assets/images/banners/reportes.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // height: calc(100vh - 100px);
    // max-height: 690px;
  }
  @media (min-width: 1800px) {
    background-image: url("../assets/images/banners/reportes.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // height: calc(100vh - 120px);
    // max-height: 1230px;
  }
  // &__actions {
  //   display: flex;
  //   justify-content: flex-end;
  //   padding: 3rem 0;
  //   .button {
  //     margin: 0 1rem;
  //   }
  // }
}
.section {
  // padding: 3rem;
  padding-top: 0px;
  .button {
    font-size: 16px;
    font-weight: 500;
  }
  h2 {
    font-weight: bold;
    font-size: 1rem;
  }
  &__video {
    width: 100%;
    margin: 1rem 0px;
    // min-height: 560px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      // @media (max-width: 650px) {
      //   min-width: 100%;
      //   width: 100%;
      // }
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        width: 90%;
        letter-spacing: 0.025em;
        font-size: 16px;
        margin: 1em 0;
        margin: 2em auto;
      }
      .button {
        width: fit-content;
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          font-size: 1.2rem;
          // max-width: 200px;
          margin: 1rem auto;
        }
      }
      @media (min-width: 1024px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.3rem;
          width: 100%;
          line-height: 1.2;
          font-weight: bold;
        }
        p {
          width: 100%;
          line-height: 1.2;
          font-size: 1.2rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          width: 100%;
          line-height: 1.2;
          font-weight: bold;
        }
        p {
          width: 100%;
          line-height: 1.2;
          font-size: 1.4rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          max-width: none;
          font-weight: bold;
          font-size: 1.2rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          width: 100%;
          line-height: 1.2;
          font-weight: bold;
        }
        p {
          width: 100%;
          line-height: 1.2;
          font-size: 1.5rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          max-width: none;
          font-weight: bold;
          font-size: 1.5rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @media (min-width: 1800px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          font-size: 1.2rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .reportes {
      padding: 0px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: stretch;
      order: 1;
      img {
        width: 100%;
        max-width: 500px;
        height: auto;
      }
      .img-center {
        margin: 1rem auto;
      }
      @include tablet() {
        img {
          max-width: none;
        }
      }
      @include laptop() {
        img {
          max-width: none;
        }
      }
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 3rem;
      width: 75%;
      h3 {
        letter-spacing: 0.018em;
        font-size: 1.2rem;
        font-weight: bold;
      }
      p {
        font-size: 1rem;
      }
    }
    &:first-child {
      padding-top: 0px;
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
.img-mg-neg {
  @include laptop() {
    margin-left: -4em;
  }
}
</style>
